import React from "react";
import VideoPlayer from "../../Components/VideoPlayer/VideoPlayer";
import { useEffect, useState } from "react";
import { getAllUseCaseVideos } from "../../api/api";

const CheckinCheckoutVideo = () => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    async function fetchVideo() {
      try {
        const data = await getAllUseCaseVideos();
        // //console.log(data?.data?.data);
        const video = data?.data?.data?.find(
          (v) => v._id === "686bb1afab7d4a58aa2e9633"
        );
        // //console.log(video);
        if (video && video.video_path) {
          setVideoUrl(video.video_path);
        }
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    }
    fetchVideo();
  }, []);

  return (
    <div>
      <nav className="navbar navbar-dark bg-dark px-3">
        <span className="navbar-brand">Check-in/Check-out Videos</span>
      </nav>

      <VideoPlayer
        videoUrl={"https://visionemptrack.greymatterz.com/" + videoUrl}
        title="Company Check-in/Check-out Video"
        description="Check-in/Check-out video for the company"
      />
    </div>
  );
};

export default CheckinCheckoutVideo;
